import { AccordionSummary, Theme, styled } from '@mui/material';

type StyledAccordionSummaryType = {
  theme: Theme;
};

const StyledAccordionSummary = styled(AccordionSummary)(
  ({ theme }: StyledAccordionSummaryType) => ({
    width: '430px',
    marginTop: '20px',
    backgroundColor: theme.palette.background.default,
    padding: 0,
    '@media (max-width:600px)': {
      maxWidth: '90%',
      marginTop: '30px',
    },
  })
);

export { StyledAccordionSummary };
